import { CSSProperties, ReactNode } from "react"

interface TableRowControlsContainerProps {
    children: ReactNode
    style?: CSSProperties
}

const TableRowControlsContainer = ({ children, style }: TableRowControlsContainerProps) => {
    return <div className="d-flex align-items-center justify-content-between gap-2" style={style}>{children}</div>
}


export default TableRowControlsContainer